var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIconGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 9.16732H11.3333V4.16732C11.3333 3.9463 11.2455 3.73434 11.0892 3.57806C10.9329 3.42178 10.7209 3.33398 10.4999 3.33398C10.2789 3.33398 10.0669 3.42178 9.91066 3.57806C9.75438 3.73434 9.66658 3.9463 9.66658 4.16732V9.16732H4.66659C4.44557 9.16732 4.23361 9.25512 4.07733 9.4114C3.92105 9.56768 3.83325 9.77964 3.83325 10.0007C3.83325 10.2217 3.92105 10.4336 4.07733 10.5899C4.23361 10.7462 4.44557 10.834 4.66659 10.834H9.66658V15.834C9.66658 16.055 9.75438 16.267 9.91066 16.4232C10.0669 16.5795 10.2789 16.6673 10.4999 16.6673C10.7209 16.6673 10.9329 16.5795 11.0892 16.4232C11.2455 16.267 11.3333 16.055 11.3333 15.834V10.834H16.3333C16.5543 10.834 16.7662 10.7462 16.9225 10.5899C17.0788 10.4336 17.1666 10.2217 17.1666 10.0007C17.1666 9.77964 17.0788 9.56768 16.9225 9.4114C16.7662 9.25512 16.5543 9.16732 16.3333 9.16732Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 10.4999,
    y1: 3.33398,
    x2: 10.4999,
    y2: 16.6673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#B7F133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42E365"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconGreen);
export default __webpack_public_path__ + "static/media/plus-icon-green.4fb4e6c186360a8b4fcf5da52272957b.svg";
export { ForwardRef as ReactComponent };